export const validatePhone = (value: string): boolean => {
  const clearedValue = value.replace(/[^0-9]+/g, '');
  // Lib is checking less than 7 and more than 15, we need only 7 <= n <= 15
  return clearedValue.length >= 7 && clearedValue.length <= 15;
};

export const validateEmail = (value: string): boolean =>
  /^[^@]+@([^@]+\.)+[^@]+$/.test(value);

export const validateRequired = (value: string): boolean => Boolean(value);
